import axios from "axios";
import {
    authorizationServicesPath,
} from "../../Constants";

const restUrl = authorizationServicesPath + '/admin/customers'

export default class AllCustomerService {

    static async getAll() {
        return axios.get(restUrl + "/get-all");
    }

    static async update(id, status) {
        return await axios.patch(restUrl + "/" + id + "/set-unable?status=" + status,
            [], {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

}